import { Checkbox } from 'Components/Core';
import { ChangeEventWithData } from 'Components/Core/types';
import { actions } from 'Data/ReduxViewModels/WorksheetBatchUpdate';
import { useDispatch, useSelector } from 'react-redux';

const WorksheetBatchUpdateSelectAllCheckbox: React.FC = () => {
  const dispatch = useDispatch();
  const allSelected = useSelector((state) => {
    const editableWorksheets = Object.entries(state.worksheetBatchUpdate.worksheets).filter(
      ([_, v]) => !(v.status.readonly.locked && !v.status.readonly.uncheckAllowed)
    );

    return (
      editableWorksheets.length > 0 &&
      editableWorksheets.every(([k, _]) => state.worksheetBatchUpdate.worksheetsState[k]?.selected)
    );
  });
  const disabled = useSelector(
    (state) =>
      state.worksheetBatchUpdate.status.applyingUpdate ||
      state.worksheetBatchUpdate.status.checking ||
      !Object.entries(state.worksheetBatchUpdate.worksheets).some(
        ([_, v]) => !(v.status.readonly.locked && !v.status.readonly.uncheckAllowed)
      )
  );
  return (
    <Checkbox
      value={allSelected}
      disabled={disabled}
      onChange={(e: ChangeEventWithData<HTMLInputElement>) =>
        dispatch(actions.setAllSelected({ selected: e.data?.value }))
      }
    />
  );
};

export default WorksheetBatchUpdateSelectAllCheckbox;
export { WorksheetBatchUpdateSelectAllCheckbox };
